import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div\n  class={{class-names\n    \"bv-text-container\"\n    (if @spacing (concat \"bv-text-container--spacing-\" @spacing))\n  }}\n  ...attributes\n>\n  {{yield}}\n</div>")